import { useEffect, useState } from "react";

import { useLocale } from "@/libraries/web-framework";
import { WAC_TO_CPAPI_LOCALE_MAP } from "@/utils/content-queries/constants.ts";

import {
    getTemplateCategories,
    JiraTemplateCategory
} from "./get-template-categories.ts";

export const isFetchInitiated = {
    value: false
};

export const useJiraTemplateCategories = () => {
    const [data, setData] = useState<JiraTemplateCategory[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<unknown>(null);
    const locale = useLocale();

    useEffect(() => {
        const fetchData = async () => {
            isFetchInitiated.value = true;
            setLoading(true);
            setError(null);
            try {
                const data = await getTemplateCategories({
                    locale: WAC_TO_CPAPI_LOCALE_MAP[locale]
                });
                setData(data.taxonomyTemplateCategoryCollection.items ?? []);
            } catch (err) {
                setError(err);
            } finally {
                setLoading(false);
            }
        };

        if (!isFetchInitiated.value) {
            void fetchData();
        }
    }, []);

    return { data, loading, error };
};
